import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const DollarIcon = ({ strokeColor = "#FF6C66", ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      <path
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="currentColor"
      />
      <path
        d="M12 6.5V8M12 8C10.4812 8 9.25 8.92865 9.25 10.0741C9.25 11.2196 10 11.8519 12 11.8519C14 11.8519 15 12.4445 15 13.926C15 15.4075 13.6569 16 12 16M12 8C13.5188 8 14.75 8.92865 14.75 10.0741M12 16V17.5M12 16C10.3431 16 9 15.0715 9 13.926"
        stroke="currentColor"
      />
    </SvgIcon>
  )
}
